import { enqueueSnackbar } from "notistack"
import React from "react"

export default function Snackbar({ messages, siteName }) {



    const renderServerSnacks = () => {
        messages.forEach(({ level: variant, message }) => {
            enqueueSnackbar(message, {
                variant,
                style: {
                    maxWidth: "100px"
                }
            })
        })
    }

    React.useEffect(renderServerSnacks, [])
    return <div></div>
}


// WEBPACK FOOTER //
// ./resources/js/react/components/Snackbar/Snackbar.jsx